import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EPAWorklistCount {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  EPAWorklistCountData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: EPAWorklistCount = {
  isLoading: false,
  error: false,
  message: null,
  EPAWorklistCountData: [],
  Items: [],
  Pagination: [],
};

const EPAWorklistCountSlice = createSlice({
  name: "EPAWorklistCount",
  initialState,
  reducers: {
    loadingEPAWorklistCount: (
      state: EPAWorklistCount,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setEPAWorklistCount: (
      state: any,
      action: PayloadAction<EPAWorklistCount>
    ) => {
      return action.payload;
    },
    clearData: (state: EPAWorklistCount, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingEPAWorklistCount, setEPAWorklistCount, clearData } =
  EPAWorklistCountSlice.actions;
export default EPAWorklistCountSlice.reducer;
